module.exports = __webpack_public_path__ + "static/media/1.0.0.76c6348c.md";